import React from 'react';

const PrivacyPolicy = () => {
  return (
    <section id="privacy-policy" className="py-16 bg-white">
      <div className="container mx-auto px-6 prose lg:prose-xl max-w-4xl">
        <h1 className="text-4xl font-extrabold text-center mb-12">Privacy Policy for Bitdeploy</h1>

        <p><strong>Last Updated:</strong> September 27, 2025</p>

        <h2 className="text-2xl font-bold mt-8">1. Introduction</h2>
        <p>
          Welcome to Bitdeploy ("we," "our," or "us"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, bitdeploy.ca (the "Site"), and use our services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
        </p>

        <h2 className="text-2xl font-bold mt-8">2. Information We Collect</h2>
        <p>
          We may collect information about you in a variety of ways. The information we may collect on the Site includes:
        </p>
        <h3 className="text-xl font-semibold mt-4">Personal Data</h3>
        <p>
          Personally identifiable information, such as your name, email address, and telephone number, and services of interest that you voluntarily give to us when you fill out the contact form on our Site. You are under no obligation to provide us with personal information of any kind; however, your refusal to do so may prevent you from using certain features of the Site and our services.
        </p>
        <h3 className="text-xl font-semibold mt-4">Derivative Data</h3>
        <p>
          Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site. This information does not typically identify you personally.
        </p>

        <h2 className="text-2xl font-bold mt-8">3. How We Use Your Information</h2>
        <p>
          Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:
        </p>
        <ul>
          <li>Respond to your inquiries, questions, and provide customer support.</li>
          <li>Provide you with information or a quote for the services you have requested.</li>
          <li>Email you with updates about our company and services, where you have consented to receive such information.</li>
          <li>Monitor and analyze usage and trends to improve your experience with the Site.</li>
          <li>Fulfill our legal and regulatory obligations.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8">4. Information Sharing and Disclosure</h2>
        <p>
          We do not sell, trade, rent, or otherwise share your Personal Information for marketing purposes with third parties. We may share information we have collected about you in certain situations:
        </p>
        <ul>
          <li>
            <strong>By Law or to Protect Rights:</strong> If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.
          </li>
          <li>
            <strong>Third-Party Service Providers:</strong> We may share your information with third parties that perform services for us or on our behalf, including data analysis, email delivery, hosting services, and customer service. These third parties are obligated to protect your data.
          </li>
        </ul>

        <h2 className="text-2xl font-bold mt-8">5. Data Security</h2>
        <p>
          We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
        </p>

        <h2 className="text-2xl font-bold mt-8">6. Our Applications</h2>
        <p>
          This Privacy Policy applies to our Site and the services offered through it. In the event that we develop and release any software applications (mobile or desktop), this Privacy Policy will also govern the use of those applications. If an application has data collection practices that differ from those described in this policy, we will provide a supplementary privacy notice specific to that application.
        </p>

        <h2 className="text-2xl font-bold mt-8">7. Your Rights</h2>
        <p>
          In accordance with Canadian and Albertan privacy laws, you have the right to:
        </p>
        <ul>
          <li>Request access to the personal information we hold about you.</li>
          <li>Request a correction to any inaccurate or outdated personal information.</li>
          <li>Withdraw your consent to our use of your personal information, subject to legal or contractual restrictions.</li>
        </ul>
        <p>To exercise these rights, please contact us using the contact information provided below.</p>

        <h2 className="text-2xl font-bold mt-8">8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons. We will notify you of any changes by updating the "Last Updated" date of this Privacy Policy.
        </p>

        <h2 className="text-2xl font-bold mt-8">9. Contact Us</h2>
        <p>
          If you have questions or comments about this Privacy Policy, please contact us at:
        </p>
        <p>
          Bitdeploy<br />
          Email: <a href="mailto:info@bitdeploy.ca" className="text-blue-600 hover:underline">info@bitdeploy.ca</a><br />
          Phone: <a href="tel:+14037154039" className="text-blue-600 hover:underline">+1(403)715-4039</a>
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
